<template>
  <div class="needscenterdetail">
    <div class="page-title">需求详情</div>
    <div class="identification-box">
      <div class="left-red-title">
        <div class="left-inner">
          <div class="border-left"></div>
          <div class="title-text">需求明细下载</div>
        </div>
      </div>
      <div class="identification-inner-content">
        <div class="identification-inner" @click="handleDownloadTest">
          <div class="inner-icon"></div>
          <div class="inner-desc">下载需求明细</div>
          <div class="icon-download"></div>
        </div>
      </div>
      <el-form
        class="basics-form"
        ref="basicsForm"
        :model="formData"
        label-position="left"
        label-width="100px"
      >
        <el-form-item label="项目名称：">
          <el-input
              class="custom-input txt-normalstyle width889"
              placeholder=""
              :value="
                formData && formData.mid_table_remark_001
                  ? formData.mid_table_remark_001
                  : '--'
              "
              :readonly="true"
            >
            </el-input>
        </el-form-item>
        <el-form-item label="项目简介：">
          <el-input
            class="custom-input txt-normalstyle project-desc custom-txt"
            v-model="formData.mid_table_remark_007"
            type="textarea"
            maxlength="500"
            show-word-limit
            placeholder="请填写"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <div class="twoitem-row">
          <div class="width460">
            <el-form-item label="发布时间：">
              <el-input
                class="custom-input txt-normalstyle width360"
                placeholder="请填写"
                v-model="formData.time_insert"
                :readonly="true"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="width460">
            <el-form-item label="截止时间：">
              <el-input
                  class="custom-input txt-normalstyle width360"
                  placeholder="请填写"
                  v-model="formData.time_4_end_after"
                  :readonly="true"
                >
                </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="twoitem-row">
          <div class="width460">
            <el-form-item label="所在地要求：">
              <el-input
                class="custom-input txt-normalstyle width360"
                placeholder="请填写"
                v-model="formData.area"
                :readonly="true"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="width460">
            <el-form-item label="要发经验要求：">
              <el-input
                  class="custom-input txt-normalstyle width360"
                  placeholder="请填写"
                  :value="
                    formData && formData.mid_table_remark_004
                      ? (formData.mid_table_remark_004 == 4001 ? '低' : (formData.mid_table_remark_004 == 4002 ? '中' : '高'))
                      : ''
                  "
                  :readonly="true"
                >
                </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="twoitem-row">
          <div class="width460">
            <el-form-item label="团队人数要求：">
              <el-input
                class="custom-input txt-normalstyle width360"
                placeholder="请填写"
                v-model="formData.mid_table_remark_005_after"
                :readonly="true"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="width460">
            <el-form-item label="开发周期要求：">
              <el-input
                  class="custom-input txt-normalstyle width360"
                  placeholder="请填写"
                  v-model="formData.mid_table_remark_006_after"
                  :readonly="true"
                >
                </el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <template v-if="userInfo.user_remark_001==101">
            <el-button
              class="custom-button btn-ff3333 btn-publish"
              >个人身份无法申请需求</el-button
            >
          </template>
          <template v-else>
            <el-button
              v-if="userInfo.user_remark_019"
              class="custom-button btn-ff3333 btn-publish"
              @click="handleSubmit"
              >立即申请</el-button
            >
            <el-button
              v-else
              class="custom-button btn-ff3333 btn-publish"
              @click="handleUpload"
              >请先上传资质</el-button
            >
          </template> 
        </el-form-item>
      </el-form>
    </div>
    <ApplyNeeds ref="dialogApplyNeeds" :needsInfo="formData" :userInfo="userInfo"></ApplyNeeds>
  </div>
</template>
<script>
import ApplyNeeds from "@/components/dialog/ApplyNeeds";
import NoneData from "@/components/NoneData";
import pageCommon from "@/utils/pagecommon";
import needsApi from "@/api/needs";
export default {
  name: "NeedsCenterDetail",
  components: {NoneData, ApplyNeeds },
  created() {
    let _this = this;
    _this.currentPage = 1;
    _this.total = 1;
    _this.isRequesting = true;
  },
  mounted() {
    let _this = this;
    _this.$store.dispatch("acCenterNavIndex", 11);    
    _this.getNeedsInfo();
  },
  data() {
    return {
      showPassword: false,
      currentPage: 1,
      pageSize: 10,
      total: 1,
      isRequesting: false,
      formData:{}
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
  },
  methods: {
    getNeedsInfo: function () {
      let _this = this;
      let requestData = {
        begin_idx: 0,
        limit: 10,
        id_public_middle_table: _this.$route.query.id,
        isloading: true,
      };
      pageCommon.apiRequestCommon(needsApi, "getNeedsData", requestData).then(
        (res) => {
          if(res.page_content&&res.page_content[0]){
            res.page_content[0].area=res.page_content[0].mid_table_remark_009&&res.page_content[0].mid_table_remark_009?res.page_content[0].mid_table_remark_009+' '+res.page_content[0].mid_table_remark_010:'--'
            res.page_content[0].mid_table_remark_005_after=res.page_content[0].mid_table_remark_005?res.page_content[0].mid_table_remark_005+'人':'--'
            res.page_content[0].mid_table_remark_006_after=res.page_content[0].mid_table_remark_006?res.page_content[0].mid_table_remark_006+'个工作日':'--'
            res.page_content[0].time_4_end_after=res.page_content[0].mid_table_remark_002==2002?res.page_content[0].time_4_end:'--'
            this.formData=res.page_content[0];
          }
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
          }
        }
      );
    },
    handleDownloadTest(){
      if(this.userInfo.user_remark_001==101){
        this.$message.error("个人身份无法下载需求包");
        return
      }
      if(this.formData.mid_table_remark_008){
        window.open(this.formData.mid_table_remark_008);
      } else {
        this.$confirm("暂无可下载的需求包, 请联系相关人员", "提示", {
          type: "warning",
          showCancelButton: false,
        }).then(() => {});
      }
    },
    handleSubmit: function () {
      let _this = this;
      let requestData = {
        begin_idx: 0,
        limit: 10,
        id_public_middle_table: _this.$route.query.id,
        isloading: true,
      };
      let requestApplyData = {
        isloading: true,
        begin_idx: 0,
        limit: 1,
        id_public_user_info: _this.userInfo.id_public_user_info,
        mid_table_remark_011: _this.$route.query.id
      };
      if(!_this.sending){
        _this.sending=true;
        pageCommon.apiRequestCommon(needsApi, "getNeedsData", requestData).then(
          (res) => {
            if(res.result_num>0){
              if(res.page_content[0].mid_table_remark_002==2001){
                pageCommon.apiRequestCommon(needsApi, "getApplyData", requestApplyData).then(
                  (res) => {
                    if(res.result_num>0){
                      _this.$message.error("您已提交过申请，工作人员会与您联系！");
                    }else{
                      _this.sending = false;
                      _this.$refs["dialogApplyNeeds"].showDialog = true;
                    }
                  },
                  (err) => {
                    _this.sending = false;
                    if (err.sysUserLoginError) {
                      _this.$message.error("系统异常，请稍后刷新重试！");
                    } else {
                    }
                  }
                );
              } else {
                _this.sending = false;
                _this.$message.error("此项目需求申请已截止，看看其他需求吧！");
              }
            }else{
              _this.sending = false;
              _this.$message.error("此需求或已被删除");
            }
          },
          (err) => {
            _this.sending = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
            }
          }
        );
      }
    },
    handleUpload: function(){
      let _this = this;
      _this.$router.push({
        path: "/mybasics"
      });
    }
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
@import "../../assets/css/center.less";
.needscenterdetail {
  position: relative;
  width: 100%;
  height: 100%;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  .identification-box,
  .tools-box{
    position: relative;
    width: 100%;
    margin-top: 88px;
    .identification-inner,
    .tools-inner {
      position: relative;
      width: 100%;
      height: 200px;
      border: 1px solid #eeeeee;
      border-radius: 4px;
      box-sizing: border-box;
      margin-top: 32px;
      display: flex;
      display: -webkit-flex;
    }
  }
  .identification-inner-content {
    display: flex;
    align-content: center;
    justify-content: space-between;
    .identification-inner {
      width: 49%;
    }
  }
  .identification-box {
    margin-right:50px;
    .identification-inner {
      padding: 40px 0 0 32px;
      display: block;
      background-color: #f4f4f4;
      position: relative;
      cursor: pointer;
      font-weight: bold;
      .inner-icon {
        width: 80px;
        height: 80px;
        margin-bottom: 20px;
        background: url(~@/assets/icon_down.png) no-repeat right top;
      }
      .inner-desc {
        color: #666666;
        text-align: left;
      }
      .icon-download {
        position: absolute;
        bottom: 42px;
        right: 26px;
        width: 46px;
        height: 46px;
        background: url(~@/assets/icon_download.png) no-repeat right top;
      }
      &:hover {
        border-color: #ec4040;
        background-color: #fff8f8;
        .inner-icon {
          background: url(~@/assets/icon_down_hover.png) no-repeat right
            top;
        }
        .inner-desc {
          color: #ec4040;
        }
        .icon-download {
          background: url(~@/assets/icon_download_current.png) no-repeat right
            top;
        }
      }
    }
  }
  .width360 {
    width: 360px;
  }
  .width460 {
    width: 460px;
  }
  .width889 {
    width: 889px;
  }
  .page-title {
    position: relative;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .page-nav-items {
      .page-parentname {
        color: rgba(153, 153, 153, 1);
      }
    }
  }
  .basics-form {
    position: relative;
    width: 100%;
    padding-top: 40px;
    padding-bottom: 48px;
    box-sizing: border-box;
    /deep/ .el-form-item {
      margin-bottom: 40px;
    }
    .twoitem-row {
      position: relative;
      width: 100%;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      justify-content: space-between;
    }

    /deep/ .el-form-item__content {
      text-align: left;
    }
    .custom-txt {
      width: 690px;
    }
    /deep/ .custom-input {
      &.input-with-unit {
        .el-input__inner {
          padding-right: 46px;
        }
        &::after {
          position: absolute;
          content: "万";
          width: 46px;
          height: 46px;
          line-height: 46px;
          right: 0;
          top: 0;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: normal;
          color: #222222;
          text-align: center;
        }
      }
      &.project-desc {
        width: 889px;
        .el-textarea__inner {
          position: relative;
          width: 889px;
          height: 170px;
          padding: 17px 13px;
          resize: none;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: normal;
          color: #222222;
          line-height: 24px;
          &:focus {
            border-color: #07060b;
          }
          &::placeholder {
            color: #c2c2c2;
          }
          &::-webkit-input-placeholder {
            /* WebKit browsers 适配谷歌 */
            color: #c2c2c2;
          }
          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 适配火狐 */
            color: #c2c2c2;
          }
          &::-moz-placeholder {
            /* Mozilla Firefox 19+ 适配火狐 */
            color: #c2c2c2;
          }
          &:-ms-input-placeholder {
            /* Internet Explorer 10+  适配ie*/
            color: #c2c2c2;
          }
        }
      }
      background-color: #fff;
    }
    .picker-uptime {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
    .btn-publish {
      width: 180px;
      height: 46px;
      line-height: 46px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
    .btn-cancel {
      width: 94px;
      height: 46px;
      line-height: 46px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #222222;
      margin-left: 40px;
    }
    .btn-back {
      width: 94px;
      height: 46px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ec4040;
      line-height: 46px;
    }
  }
  .cell-row {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    text-align: left;
  }
  .cell-column {
    position: relative;
    text-align: left;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .project-name-cell {
    position: relative;
    width: 156px;
    margin-right: 20px;
  }
  .id-secret-cell {
    position: relative;
    width: 187px;
    margin-right: 25px;
  }
  .status-cell {
    position: relative;
    width: 65px;
    margin-right: 35px;
  }
  .white-cell {
    position: relative;
    width: 96px;
    margin-right: 30px;
  }
  .creattime-cell {
    position: relative;
    width: 83px;
    margin-right: 38px;
  }
  .operate-cell {
    position: relative;
    width: 203px;
    text-align: center;
  }
  .table-header-box {
    position: relative;
    height: 60px;
    background: #f4f4f4;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 35px;
    margin-bottom: 24px;
    .status-cell {
      text-align: center;
    }
    .creattime-cell {
      text-align: center;
    }
  }
  .table-list-box {
    position: relative;
    flex: 1;
    width: 100%;
    margin-bottom: 24px;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .datalist-row {
    height: 100px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 24px;
    &:nth-child(2n) {
      background: #f6f6f6;
    }
    &:last-child {
      margin-bottom: 0;
    }
    .cell-column {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
    }
    .operate-cell {
      position: relative;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ec4040;
      line-height: 16px;
      div {
        cursor: pointer;
      }
    }
    .white-cell {
      text-align: center;
    }
  }
}
</style>